/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdmissionsBoardResponse } from './AdmissionsBoardResponse';
import {
    AdmissionsBoardResponseFromJSON,
    AdmissionsBoardResponseFromJSONTyped,
    AdmissionsBoardResponseToJSON,
    AdmissionsBoardResponseToJSONTyped,
} from './AdmissionsBoardResponse';

/**
 * 
 * @export
 * @interface GetAdmissionsBoard200Response
 */
export interface GetAdmissionsBoard200Response {
    /**
     * 
     */
    data: AdmissionsBoardResponse;
}

/**
 * Check if a given object implements the GetAdmissionsBoard200Response interface.
 */
export function instanceOfGetAdmissionsBoard200Response(value: object): value is GetAdmissionsBoard200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetAdmissionsBoard200ResponseFromJSON(json: any): GetAdmissionsBoard200Response {
    return GetAdmissionsBoard200ResponseFromJSONTyped(json, false);
}

export function GetAdmissionsBoard200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdmissionsBoard200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': AdmissionsBoardResponseFromJSON(json['data']),
    };
}

export function GetAdmissionsBoard200ResponseToJSON(json: any): GetAdmissionsBoard200Response {
    return GetAdmissionsBoard200ResponseToJSONTyped(json, false);
}

export function GetAdmissionsBoard200ResponseToJSONTyped(value?: GetAdmissionsBoard200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': AdmissionsBoardResponseToJSON(value['data']),
    };
}

